import React, { useState } from 'react'
import agency from '../../../../api/agency/hooks'
import AdminLoader from '../../Components/AdminLoader/AdminLoader'
import CardTableView from '../../Components/CardTableView/CardTableView'

const OfficeList = () => {
    const { data: offices, isLoading } = agency.GetAgencyOffices.useQuery()

    const [filteredOffices, setFilteredOffices] = useState([])

    return isLoading ? (
        <AdminLoader />
    ) : (
        <>
            <CardTableView
                data={offices?.items}
                fetching={isLoading}
                filteredData={filteredOffices}
                setFilteredData={setFilteredOffices}
                searchFields={{ firstName: 'name' }}
                editButtonLink={'/admin/office'}
            />
        </>
    )
}

export default OfficeList
